import { IsString, IsOptional, IsBoolean, IsUUID, MaxLength, ValidateIf, IsArray, IsInt } from 'class-validator';
import { SopRelationshipDto } from './sop-relationship.dto';

export class CreateComplaintsProcessConfigRequestDto {
    @IsOptional()
    @ValidateIf((o) => o.intakeReportOrganizationId !== '' && o.intakeReportOrganizationId != null)
    @IsUUID()
    intakeReportOrganizationId?: string;

    @IsOptional()
    @IsString()
    @MaxLength(255)
    intakeReportEmail?: string;

    @IsOptional()
    @IsString()
    @MaxLength(50)
    intakeReportPhone?: string;

    @IsOptional()
    @IsString()
    @MaxLength(255)
    firstProvidedToEmail?: string;

    @IsOptional()
    @IsString()
    @MaxLength(255)
    qncReceivesFromEmail?: string;

    @IsOptional()
    @IsString()
    @MaxLength(255)
    qncSendsToEmail?: string;

    @IsOptional()
    @IsBoolean()
    reconciliationRequired?: boolean;

    @IsOptional()
    @IsString()
    @MaxLength(50)
    reconciliationFrequency?: string;

    @IsOptional()
    @IsString()
    @MaxLength(100)
    investigationReportFrom?: string;

    @IsOptional()
    @IsInt()
    investigationReportDueDays?: number;

    @IsOptional()
    @IsInt()
    zenProjectDueDays?: number;

    @IsOptional()
    @IsString()
    notes?: string;

    @IsOptional()
    @IsArray()
    sops?: SopRelationshipDto[];

    @IsOptional()
    @IsArray()
    @IsUUID('4', { each: true })
    deletedSopIds?: string[];
}
